var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8731 36.3747C15.6727 37.2083 21.1904 37.1326 22.15 36.5263C24.1491 35.3895 38.0632 19.5503 25.9883 14.9274C16.7922 11.3655 14.7931 19.3987 13.8335 20.0808C11.9943 21.4449 13.3537 34.7832 14.8731 36.3747Z",
    fill: "#EBA352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4745 35.8465C30.5604 35.9223 37.3575 37.8169 26.2422 37.8169C21.8441 37.8169 18.0856 35.0887 18.0856 31.2994V31.2236C24.9627 26.9038 13.4476 28.7985 15.2069 18.5674C15.7666 15.1571 19.605 14.9297 24.6429 14.475C28.8811 14.0961 43.195 19.2495 43.195 19.2495C48.3128 20.9926 50.232 35.8465 44.4745 35.8465Z",
    fill: "#FFDD67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4824 12.2794C16.7214 10.8395 27.277 14.7045 27.277 14.7045L20.7997 30.1648C20.7997 30.1648 -2.07061 29.5585 5.36624 23.6472C11.6036 18.7212 11.3637 14.3256 14.4824 12.2794Z",
    fill: "#FFDD67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62458 24.3273C2.86533 28.4955 18.9385 29.1776 21.0976 29.2534L20.6978 30.1628C20.6978 30.1628 -0.413285 29.5565 4.62458 24.3273ZM20.4579 21.2959C23.1767 25.2367 24.3762 26.0704 24.3762 26.0704C24.3762 26.0704 21.6574 25.4641 19.8181 22.8874L20.4579 21.2959Z",
    fill: "#EBA352"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3013 20.4648C21.5008 20.4648 20.3013 25.9972 21.6607 27.5129C21.3408 28.4981 19.2617 27.8918 19.2617 27.8918C19.2617 27.8918 19.9014 21.0711 19.8215 20.6922L20.3013 20.4648Z",
    fill: "#EBA352"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0703 25.3889L15.2698 26.5257C15.2698 26.5257 26.2252 16.9767 29.2639 15.0821L25.6654 14.3242L14.0703 25.3889Z",
    fill: "#EBA352"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 28.4185L8.71773 31.6773L36.386 5.53124L32.9475 2.27246L5.19922 28.4185Z",
    fill: "#428BC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5127 2.87985L35.8317 5.00185L38.8704 2.19778L36.5514 0L33.5127 2.87985ZM28.6348 5.38077L33.1129 9.54898L33.9125 8.86691L29.3545 4.62292L28.6348 5.38077Z",
    fill: "#574137"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4414 10.9893L22.0811 11.5198L29.3581 4.62327L28.7983 4.09277L21.4414 10.9893Z",
    fill: "#574137"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71559 31.6797L0.878906 35.7721L5.19708 28.4209L8.71559 31.6797Z",
    fill: "#A9B5AE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.0733L0.559763 36.6038L2.15909 35.0881L1.59932 34.5576L0 36.0733Z",
    fill: "#574137"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9027 33.6477C30.0627 33.193 30.1426 32.814 30.2226 32.3593C30.3026 32.132 30.3825 31.9046 30.4625 31.6015C31.2622 28.3427 18.2277 26.2207 18.2277 26.2207L17.2681 25.9933C15.189 25.5386 10.6309 25.0081 7.27233 28.6458C4.95331 31.2225 7.3523 33.7993 9.51138 33.9508C15.3489 34.4813 19.6671 35.8455 22.9457 37.1338C25.8245 38.4222 28.7033 36.9822 29.9027 33.6477Z",
    fill: "#FFDD67"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1973 27.2089C15.1182 26.5269 11.7596 24.7838 7.44141 28.4215C11.4397 23.7986 17.917 26.1479 18.1569 26.2237C24.2343 26.9816 28.2326 24.708 28.2326 24.708C27.0331 27.5879 20.156 28.1941 17.1973 27.2089ZM26.6333 36.8337C37.7486 36.8337 31.0314 34.9391 44.8655 34.8633C46.065 34.8633 47.0246 33.7265 47.5844 32.6655C47.1846 34.7117 45.9851 35.8485 44.4657 35.8485C30.5516 35.9243 37.2688 37.8947 26.1535 37.8947C21.7553 37.8947 17.5971 35.7727 14.0786 34.7117C13.9986 34.6359 22.475 36.8337 26.6333 36.8337Z",
    fill: "#EBA352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingHand);
export default __webpack_public_path__ + "static/media/writing-hand.cef34f9ed8389c65f9627bb6c454e24f.svg";
export { ForwardRef as ReactComponent };